import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * DemoModeBanner — Displays a dismissible banner on pages using mock/placeholder data.
 *
 * Props:
 *   message  — optional custom message (default: generic demo data notice)
 *   compact  — if true, renders inline-style instead of full-width bar
 */
export default function DemoModeBanner({ message, compact = false }) {
  const [dismissed, setDismissed] = React.useState(false);
  if (dismissed) return null;

  const text = message || 'This page displays demo data for preview purposes. Live data integration coming soon.';

  if (compact) {
    return (
      <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs mb-3"
        style={{ background: 'rgba(255, 170, 0, 0.08)', border: '1px solid rgba(255, 170, 0, 0.2)' }}>
        <AlertTriangle size={12} className="text-amber-500 shrink-0" />
        <span className="text-amber-400/90">{text}</span>
        <button onClick={() => setDismissed(true)}
          className="ml-auto text-amber-500/50 hover:text-amber-400 text-xs leading-none">&times;</button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3 px-4 py-2.5 rounded-[10px] mb-4"
      style={{ background: 'rgba(255, 170, 0, 0.06)', border: '1px solid rgba(255, 170, 0, 0.15)' }}>
      <AlertTriangle size={16} className="text-amber-500 shrink-0" />
      <span className="text-sm text-amber-400/90 flex-1">{text}</span>
      <button onClick={() => setDismissed(true)}
        className="text-amber-500/40 hover:text-amber-400 text-lg leading-none px-1">&times;</button>
    </div>
  );
}
